"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = Table;
exports.TableHeader = TableHeader;
exports.TableBody = TableBody;
exports.TableFooter = TableFooter;
exports.TableHead = TableHead;
exports.TableRow = TableRow;
exports.TableCell = TableCell;
exports.TableCaption = TableCaption;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const cn_1 = require("cn");
function Table({ className, ...props }) {
    return ((0, jsx_runtime_1.jsx)("div", { "data-slot": "table-container", className: "relative w-full overflow-auto", children: (0, jsx_runtime_1.jsx)("table", { "data-slot": "table", className: (0, cn_1.cn)('w-full caption-bottom text-sm', className), ...props }) }));
}
function TableHeader({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("thead", { "data-slot": "table-header", className: (0, cn_1.cn)('bg-card [&_tr]:border-b', className), ...props });
}
function TableBody({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("tbody", { "data-slot": "table-body", className: (0, cn_1.cn)('[&_tr:last-child]:border-0', className), ...props });
}
function TableFooter({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("tfoot", { "data-slot": "table-footer", className: (0, cn_1.cn)('border-t bg-muted/50 font-medium [&>tr]:last:border-b-0', className), ...props });
}
function TableRow({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("tr", { "data-slot": "table-row", className: (0, cn_1.cn)('border-b transition-colors hover:bg-muted', className), ...props });
}
function TableHead({ className, ...props }) {
    return ((0, jsx_runtime_1.jsx)("th", { "data-slot": "table-head", className: (0, cn_1.cn)('h-9 whitespace-nowrap px-3 text-left align-middle text-xs font-medium text-muted-foreground', className), ...props }));
}
function TableCell({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("td", { "data-slot": "table-cell", className: (0, cn_1.cn)('overflow-hidden px-3 py-2 align-middle whitespace-nowrap text-ellipsis', className), ...props });
}
function TableCaption({ className, ...props }) {
    return (0, jsx_runtime_1.jsx)("caption", { "data-slot": "table-caption", className: (0, cn_1.cn)('mt-4 text-sm text-muted-foreground', className), ...props });
}
